import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import { LogoMark } from '@/components/brand/Logo';
import { useAuth } from './useAuth';
import styles from './AccountPicker.module.css';

/**
 * Full-screen account selector shown when the logged-in Staff has more than
 * one Client to choose from. Mirrors the rsv-manager / fitsuite picker UX —
 * each row is the Client name with the staff role below, plus a logout
 * escape hatch.
 */
export function AccountPicker() {
  const { accounts, selectAccount, logout } = useAuth();

  return (
    <Container size="sm">
      <div className={styles.wrap}>
        <header className={styles.header}>
          <LogoMark size={48} className={styles.glow} />
          <h1 className={styles.title}>¿Con qué cuenta entras?</h1>
          <p className={styles.subtitle}>
            Tu acceso tiene varios clientes. Elige con cuál quieres operar — podrás cambiar
            cerrando sesión.
          </p>
        </header>

        <ul className={styles.list}>
          {accounts.map((account) => {
            const name = account.client.name || 'Cliente sin nombre';
            const role = account.staff.name || 'Staff';
            return (
              <li key={account.index}>
                <button
                  type="button"
                  className={styles.option}
                  onClick={() => selectAccount(account.index)}
                >
                  <span className={styles.optionBody}>
                    <strong className={styles.optionName}>{name}</strong>
                    <small className={styles.optionRole}>{role}</small>
                  </span>
                  <span className={styles.optionArrow} aria-hidden="true">→</span>
                </button>
              </li>
            );
          })}
        </ul>

        <div className={styles.footer}>
          <Button variant="ghost" size="sm" onClick={() => void logout()}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    </Container>
  );
}
